export const ATTENDANCE = '/attendance/' as const
export const ATTENDANCE_GROUP = `${ATTENDANCE}group` as const
export const ATTENDANCE_CSV = `${ATTENDANCE}import` as const
export const ATTENDANCE_MODULES = `${ATTENDANCE}modules` as const
export const ATTENDANCE_TABLE = `${ATTENDANCE}table` as const
export const ATTENDANCE_TABLE_STUDENT = `${ATTENDANCE_TABLE}/student` as const
export const ATTENDANCE_TABLE_STUDENT_LIST = `${ATTENDANCE_TABLE_STUDENT}/list` as const
export const ATTENDANCE_TABLE_MODULE = `${ATTENDANCE_TABLE}/module` as const
export const ATTENDANCE_FACE_ID_IMPORT = `${ATTENDANCE}face-id/import` as const
export const ATTENDANCE_FACE_ID_ALL = `${ATTENDANCE}face-id/all` as const
